import * as React from "react";
import {Doughnut} from 'react-chartjs-2';

export class DoughnutChat extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        let {data, title, backgroundColor, backgroundHoverColor, legend} = this.props;
        const config = {
            labels: data.map((obj: any) => {
                return obj.label;
            }),
            datasets: [{
                label: title,

                data: data.map((obj: any) => {
                    return obj.value;
                }),
                backgroundColor: backgroundColor,
                hoverBackgroundColor: backgroundHoverColor,
            }]
        };
        const options = {
            resize: true,
            cutoutPercentage: 70,
            legend: legend,
        };
        return (
            <>
                {title ?
                    <h4 className="text-center py-3 mt-2">{title}</h4>
                    : ''}
                <Doughnut data={config} options={options}/>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/charts/DoughnutChat.tsx